import { environment } from "src/environments/environment";

/**
 * Constantes de API do visual web (antes exportadas pelo main.ts, o que
 * criava import circular com bootstrapApplication e quebrava o Karma).
 * Valores centralizados nos environments (plano de unificação, Fase 1).
 */
export const endpointBase = environment.apiBase;
export const endpointAuth = environment.authBase;
export const mediaBase = environment.mediaBase;
export const applicationClientId = environment.clientId;
export const clientSecret = environment.clientSecret;
